export var getMonthsToDisplay = function getMonthsToDisplay(date, isUserOnMobile) {
  return Array(isUserOnMobile ? 1 : 4).fill(date).map(function (item, index) {
    return item.clone().add(index, 'month');
  });
};